import { useState, useCallback, useEffect } from 'react';

const TICK_INTERVAL = 1000;

export function useTimer({ time, format, isStopped = false, isCountUp = false, dateNow = Date.now }) {
  // To prevent SSR hidration mismatch, display value will be initialized when hook is mounted.
  const [displayTime, setDisplayTime] = useState(null);
  const refreshDisplayTime = useCallback(() => {
    const now = dateNow();
    const newDisplayTime = format(isCountUp ? now - time : time - now);

    setDisplayTime(newDisplayTime);
  }, [time, format, isCountUp]);

  useEffect(() => {
    refreshDisplayTime();
  }, [refreshDisplayTime]);

  useEffect(() => {
    if (isStopped) return undefined;

    const intervalId = setInterval(refreshDisplayTime, TICK_INTERVAL);

    return () => clearInterval(intervalId);
  }, [refreshDisplayTime, isStopped]);

  return displayTime;
}
